import hoistNonReactStatic from 'hoist-non-react-statics';
import invariant from 'invariant';
import * as React from 'react';
import ReactDOM from 'react-dom';
import { omit } from 'lodash';

import userAgent from 'lib/currentUserAgent';

export const layerStack = [];

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'layer' implicitly has an 'any' type.
function shouldHideLayerOnEvent(layer, event) {
  if (!layer.props.hideOnBlur) {
    return false;
  }

  const context = layer.props.context;
  if (context && context.contains(event.target)) {
    return false;
  }

  const node = ReactDOM.findDOMNode(layer);
  invariant(node && 'contains' in node, 'withLayerHideOnBlurTrigger findDOMNode returned faulty');
  // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
  return !node.contains(event.target);
}

export function hideOnBlur(event: any) {
  // @ts-expect-error ts-migrate(7034) FIXME: Variable 'layersToHide' implicitly has type 'any[]... Remove this comment to see the full error message
  let layersToHide = [];
  // @ts-expect-error ts-migrate(7034) FIXME: Variable 'layersToKeep' implicitly has type 'any[]... Remove this comment to see the full error message
  const layersToKeep = [];

  // split the layers into 2 bucket.
  let i = layerStack.length;
  while (i--) {
    const layer = layerStack[i];
    if (shouldHideLayerOnEvent(layer, event)) {
      layersToHide.push(layer);
    } else {
      layersToKeep.push(layer);
    }
  }

  // If a layer has a button that open another layer
  // then clicking inside the second layer should not close
  // the first layer.
  // @ts-expect-error ts-migrate(7005) FIXME: Variable 'layersToHide' implicitly has an 'any[]' ... Remove this comment to see the full error message
  layersToHide = layersToHide.filter((layerToHide) => {
    // $FlowFixMe where does context come from
    const contextToHide = layerToHide.props.context;

    // @ts-expect-error ts-migrate(7005) FIXME: Variable 'layersToKeep' implicitly has an 'any[]' ... Remove this comment to see the full error message
    const shouldFilterOut = layersToKeep.some((layerToKeep) => {
      const nodeToKeep = ReactDOM.findDOMNode(layerToKeep);
      invariant(
        nodeToKeep instanceof window.HTMLElement,
        'layersToHide findDOMNode returned non HTMLElement'
      );
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      return !nodeToKeep.contains(contextToHide);
    });

    return !shouldFilterOut;
  });

  layersToHide.forEach((layer) => {
    // Enqueue this at the end of the event queue to allow click events to fire in IE
    // $FlowFixMe type the layers
    setTimeout(layer.props.onRequestHide, 0);
  });
}

function withLayerHideOnBlurTrigger<Props extends {}>(
  Child: React.ComponentType<
    {
      hideOnBlur?: boolean;
    } & Props
  >
) {
  class LayerHideOnBlur extends React.Component<Props> {
    static defaultProps = {
      hideOnBlur: true,
    };

    // $FlowFixMe property `displayName` not found in Component object type
    displayName = `withLayerHideOnBlurTrigger(${Child.displayName})`;

    componentDidMount() {
      if (layerStack.length === 0) {
        if (userAgent.firefox()) {
          document.addEventListener('focus', hideOnBlur, true);
        } else {
          document.addEventListener('focusin', hideOnBlur, false);
        }
        document.addEventListener('mousedown', hideOnBlur, false);
      }

      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'this' is not assignable to param... Remove this comment to see the full error message
      layerStack.push(this);
    }

    componentWillUnmount() {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'this' is not assignable to param... Remove this comment to see the full error message
      const index = layerStack.indexOf(this);
      if (index >= 0) {
        layerStack.splice(index, 1);

        if (layerStack.length === 0) {
          if (userAgent.firefox()) {
            document.removeEventListener('focus', hideOnBlur, true);
          } else {
            document.removeEventListener('focusin', hideOnBlur, false);
          }
          document.removeEventListener('mousedown', hideOnBlur, false);
        }
      }
    }

    render() {
      const childProps = omit(this.props, 'hideOnBlur');
      // @ts-expect-error
      return <Child {...childProps} />;
    }
  }
  return hoistNonReactStatic(LayerHideOnBlur, Child);
}

export default withLayerHideOnBlurTrigger;
